import { render, staticRenderFns } from "./deployment_list.vue?vue&type=template&id=b12ab9f2"
import script from "./deployment_list.vue?vue&type=script&lang=js"
export * from "./deployment_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports